/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMemo } from "react";
import { CART_LINE_ID_FIELD, CART_LINE_TYPES } from "../constants/constants";

const SUPPORTED_TYPES = new Set(Object.values(CART_LINE_TYPES));

export const useProcessedCartEntities = (invoice) => {
  return useMemo(() => {
    if (!invoice?.lines?.length) {
      return { items: [], currency: null };
    }

    const items = invoice.lines
      .filter((line) => SUPPORTED_TYPES.has(line.type))
      .map((line) => ({
        id: line[CART_LINE_ID_FIELD[line.type]] ?? line.id,
        type: line.type,
        name: line.name,
        price: line.price,
        qty: line.qty ?? 1,
        currency: line.currency,
        printLink: line.promotion_instance?.print_link ?? null,
      }));

    const currency = invoice.lines.find((l) => l.currency)?.currency || invoice.currency || null;

    return { items, currency };
  }, [invoice]);
};